import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: '📘',
  number: 'Tomo 1',
  title: 'Procesos de la Comunicación y Vínculos Humanos',
  subtitle: 'La base que tus alumnos necesitan para entender todo lo demás',
  problem: 'El primer contacto con la comunicación puede ser el más transformador o el más aburrido. Este tomo convierte un tema que parece obvio en algo profundo, aplicable y relevante para tus alumnos desde el primer día.',
  bullets: ['Los modelos de comunicación actualizados para el siglo XXI', 'Los 5 axiomas de Watzlawick explicados con ejemplos cotidianos', 'Las 6 funciones del lenguaje aplicadas a redes sociales y publicidad', 'Escucha activa, asertividad y técnica del Mensaje YO', 'Barreras de la comunicación en la era digital', 'Dinámicas de grupo, liderazgo comunicacional y resolución de conflictos'],
  result: 'Tus alumnos entienden la comunicación como un sistema complejo y vivo, no como un esquema de flechas que olvidarán al día siguiente.'
}, {
  icon: '📗',
  number: 'Tomo 2',
  title: 'Medios Masivos, Sociedad y Opinión Pública',
  subtitle: 'El tomo que transforma a tus alumnos en lectores críticos de la realidad',
  problem: 'Este es el tomo que más impacto tiene fuera del aula. Los alumnos salen con herramientas reales para leer el mundo que los rodea de una manera completamente diferente.',
  bullets: ['Historia de los medios masivos en Latinoamérica', 'La Teoría de la Agenda Setting con ejemplos regionales actuales', 'El Framing: cómo los medios encuadran la realidad', 'La Espiral del Silencio y la opinión pública', 'Concentración mediática y democracia en nuestra región', 'Géneros periodísticos y ética del periodismo', 'Fake News: tipos, mecanismos y herramientas de verificación'],
  result: 'Tus alumnos dejan de consumir medios pasivamente y empiezan a leerlos críticamente. Eso no lo olvidan nunca.'
}, {
  icon: '📙',
  number: 'Tomo 3',
  title: 'El Ecosistema Digital — Algoritmos y Nuevas Narrativas',
  subtitle: 'El módulo que más dudas genera y mejor resuelto está en este pack',
  problem: 'Este es el tomo que tus alumnos más necesitan y que menos docentes saben cómo enseñar. Aquí está todo lo que pasa en la pantalla que tienen en el bolsillo explicado de manera que cambia comportamientos reales.',
  bullets: ['Cómo funcionan realmente los algoritmos de TikTok, Instagram y YouTube', 'La economía de la atención y el diseño persuasivo', 'Identidad digital y el yo curado en redes sociales', 'Consecuencias psicológicas del mundo digital en adolescentes', 'Ciberbullying: tipos, protocolos y respuesta pedagógica', 'Los memes como lenguaje cultural e influencers como nuevos actores', 'Ciudadanía digital, seguridad, IA y deepfakes'],
  result: 'Tus alumnos pasan de ser usuarios pasivos de las plataformas a ciudadanos digitales conscientes. Eso es formación para la vida.',
  popular: true
}, {
  icon: '📕',
  number: 'Tomo 4',
  title: 'Comunicación Institucional, Publicidad y Consumo',
  subtitle: 'El cierre que conecta la teoría con el mundo real',
  problem: 'Muchos alumnos llegan al final del año sin entender cómo todo lo aprendido se conecta con lo que ven en publicidad, en política y en el mercado. Este tomo hace esa conexión de manera poderosa e inolvidable.',
  bullets: ['La publicidad como sistema de producción de significados', 'Neuromarketing y publicidad emocional', 'El Storytelling y el Viaje del Héroe en la comunicación de marcas', 'Los 12 arquetipos de marca con ejemplos latinoamericanos', 'Comunicación institucional, identidad corporativa y gestión de crisis', 'Análisis crítico de la publicidad y los estereotipos de género', 'Greenwashing y el consumo como acto político y social'],
  result: 'Tus alumnos cierran el año entendiendo que la comunicación no es solo académica. Es el lenguaje con que el poder habla. Y ahora ellos saben leerlo.'
}];
export function TomosSection() {
  return <section className="py-24 px-4 bg-black" data-id="element-295">
      <div className="max-w-6xl mx-auto" data-id="element-296">
        <div className="text-center mb-16" data-id="element-297">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4" data-id="element-298">
            📘 Los 4 Tomos del Mega Pack
          </h2>
          <p className="text-xl text-gold-light" data-id="element-299">
            Material completo para el aula
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-300">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className={`bg-dark-card rounded-2xl border ${tomo.popular ? 'border-gold shadow-[0_0_30px_rgba(212,175,55,0.15)]' : 'border-dark-border'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-301">
              {tomo.popular && <div className="absolute top-6 right-[-35px] bg-gold text-black font-bold text-xs py-1 px-10 rotate-45 shadow-lg" data-id="element-302">
                  EL MÁS POPULAR
                </div>}

              <div className="flex items-center gap-4 mb-6" data-id="element-303">
                <span className="text-4xl" data-id="element-304">{tomo.icon}</span>
                <div data-id="element-305">
                  <div className="text-gold font-bold text-sm uppercase tracking-wider" data-id="element-306">
                    {tomo.number}
                  </div>
                  <h3 className="text-2xl font-serif font-bold leading-tight mt-1" data-id="element-307">
                    {tomo.title}
                  </h3>
                </div>
              </div>

              <p className="text-white font-medium mb-6 italic border-l-2 border-gold/50 pl-4" data-id="element-308">
                {tomo.subtitle}
              </p>

              <div className="mb-6" data-id="element-309">
                <h4 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-2" data-id="element-310">
                  ¿Qué resuelve en el aula?
                </h4>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-311">
                  {tomo.problem}
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-312">
                {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-313">
                    <CheckCircle2 size={18} className="text-gold shrink-0 mt-0.5" data-id="element-314" />
                    <span className="text-gray-200 text-sm" data-id="element-315">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 mt-auto" data-id="element-316">
                <span className="text-gold font-bold block mb-1" data-id="element-317">
                  Resultado:
                </span>
                <p className="text-white text-sm" data-id="element-318">{tomo.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}